import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/inventories/template/template-loading';

export const Route = createFileRoute('/_private/inventory/_template')({
  pendingComponent: TemplateLoading,
});
